import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

/** Gemella di `asFormArray`: `form.get('x')` restituisce sempre `AbstractControl`, qui lo si dichiara `FormGroup` per gli input tipizzati. */
@Pipe({
    name: 'asFormGroup',
    standalone: false
})
export class CastToFormGroupPipe implements PipeTransform {
  public transform(item: AbstractControl): FormGroup {
    return item as FormGroup;
  }
}
